import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="利用規約">
      <p className="dw-legal__date">最終更新日：2026年3月14日</p>
      <p>本利用規約（以下「本規約」）は、合同会社GK3（以下「当社」）が提供するナイトワーク求人マッチングサービス「DressWork」（以下「本サービス」）の利用条件を定めるものです。本サービスをご利用いただく前に、本規約をよくお読みください。</p>
      <h2>第1条（適用）</h2>
      <p>本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。ユーザーが本サービスを利用した時点で、本規約に同意したものとみなします。</p>
      <h2>第2条（定義）</h2>
      <p>「ユーザー」とは、本サービスを利用する全ての個人を指します。</p>
      <p>「求人情報」とは、本サービス上で提供される店舗の採用に関する情報を指します。</p>
      <p>「コンテンツ」とは、ユーザーが本サービスに投稿・送信するテキスト、画像、その他のデータを指します。</p>
      <h2>第3条（利用登録）</h2>
      <p>本サービスの利用にあたり、ユーザーは電話番号による認証を行い、必要な情報を提供するものとします。</p>
      <p>当社は、以下の場合に利用登録を拒否することがあります。</p>
      <p>（1）登録情報に虚偽の内容が含まれる場合</p>
      <p>（2）18歳未満の方が登録を申請した場合</p>
      <p>（3）過去に本規約に違反したことがある場合</p>
      <p>（4）その他、当社が利用登録を適当でないと判断した場合</p>
      <h2>第4条（利用条件）</h2>
      <p>本サービスは18歳以上の方のみご利用いただけます。</p>
      <h2>第5条（禁止事項）</h2>
      <p>（1）法令又は公序良俗に違反する行為</p>
      <p>（2）犯罪行為に関連する行為</p>
      <p>（3）虚偽の情報を登録・送信する行為</p>
      <p>（4）当社、他のユーザー、又は第三者の権利を侵害する行為</p>
      <p>（5）本サービスの運営を妨害するおそれのある行為</p>
      <p>（6）不正アクセス、又はこれを試みる行為</p>
      <p>（7）他のユーザーに関する個人情報等を収集又は蓄積する行為</p>
      <p>（8）他のユーザーに成りすます行為</p>
      <p>（9）反社会的勢力に対して直接又は間接に利益を供与する行為</p>
      <p>（10）その他、当社が不適切と判断する行為</p>
      <h2>第6条（本サービスの提供の停止等）</h2>
      <p>当社は、保守点検、天災、その他やむを得ない事由がある場合、事前通知なく本サービスの全部又は一部を停止できるものとします。</p>
      <h2>第7条（退会）</h2>
      <p>ユーザーは、アプリ内の退会機能を通じて、いつでもアカウントを削除し退会できます。</p>
      <h2>第8条（免責事項）</h2>
      <p>当社は、求人情報の正確性、完全性等について保証しません。ユーザーと求人店舗間のトラブルについて、一切の責任を負いません。</p>
      <h2>第9条（サービス内容の変更等）</h2>
      <p>当社は、ユーザーに通知することなく本サービスの内容を変更又は提供を中止できるものとします。</p>
      <h2>第10条（利用規約の変更）</h2>
      <p>当社は、必要と判断した場合、いつでも本規約を変更できるものとします。</p>
      <h2>第11条（個人情報の取扱い）</h2>
      <p>当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱います。</p>
      <h2>第12条（準拠法・裁判管轄）</h2>
      <p>本規約の解釈にあたっては日本法を準拠法とし、紛争が生じた場合には当社本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。</p>
      <p className="dw-legal__company">合同会社GK3</p>
    </LegalLayout>
  );
}
